import { useCallback, useState } from 'react';

export type ViewMode = 'grid' | 'list';

/** Vista en tarjetas o en lista, recordada por pantalla en este navegador. */
export function useViewMode(screen: string, fallback: ViewMode = 'grid'): [ViewMode, (m: ViewMode) => void] {
  const key = `bf-view:${screen}`;
  const [mode, setMode] = useState<ViewMode>(() => {
    try {
      const v = window.localStorage.getItem(key);
      return v === 'grid' || v === 'list' ? v : fallback;
    } catch {
      return fallback;
    }
  });
  const update = useCallback(
    (m: ViewMode) => {
      setMode(m);
      try {
        window.localStorage.setItem(key, m);
      } catch {
        /* sin almacenamiento: se usa solo en esta visita */
      }
    },
    [key],
  );
  return [mode, update];
}
